import React from "react";
import { getFormattedDate } from "../../util/dateFormatting";
import i18nService from "../../util/Internationalization/i18n/i18n";

interface IProps {
    alertInfo: any;
}
const SexOffender = ({ alertInfo }: any) => {
    const details = alertInfo[0].alertDetails.alertItemDetails;
    let keys = Object.keys(details);
    for (const key in details) {
        if (details[key] === "") {
            delete details[key];
        }
    }
    let values = Object.keys(details);
    return (
        <>
            {alertInfo.map((alert: any, index: number) => {
                return (
                    <>
                        {keys.length !== 0 && (
                            <div role="row" className="data-row" key={alert.alertId}>
                                <div role="gridcell" className="link-item">
                                    {values.length > 2 ? (
                                        <button
                                            type="button"
                                            aria-expanded="false"
                                            className="link-button alert-popup-focus"
                                            id={`alert-${index}`}
                                            onClick={() => toggle(`alert-${index}-details`, `alert-${index}`)}
                                        >
                                            <span className="row link-item">
                                                <div className="data-row condensed row">
                                                    <span className="link-title">
                                                        <span className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status" style={{ display: "none" }}>
                                                            Show
                                                        </span>{" "}
                                                    </span>
                                                    <div className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                        <div className="data-label" id={`alert-${index}-Full-Name`}>Full Name</div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                        <div className="data-value">
                                                            {alert.alertDetails.alertItemDetails["Full Name"]}
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                        <div className="data-label" id={`alert-${index}-Address`}>Address</div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                        <div
                                                            className="data-value"
                                                            dangerouslySetInnerHTML={{ __html: alert.alertDetails.alertItemDetails["Address"] }}
                                                        ></div>
                                                    </div>
                                                </div>
                                            </span>
                                        </button>
                                    ) : (
                                        <button type="button" className="link-button link-item-value0" id={`alert-${index}`}>
                                            <span className="row link-item">
                                                <div className="data-row condensed row">
                                                    <span className="link-title">
                                                        <span className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status" style={{ display: "none" }}>
                                                            Show
                                                        </span>{" "}
                                                    </span>
                                                    <div className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                            <div className="data-label" id={`alert-${index}-Full-Name`}>Full Name</div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                        <div className="data-value">
                                                            {alert.alertDetails.alertItemDetails["Full Name"]}
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                            <div className="data-label" id={`alert-${index}-Address`}>Address</div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                        <div
                                                            className="data-value"
                                                            dangerouslySetInnerHTML={{ __html: alert.alertDetails.alertItemDetails["Address"] }}
                                                        ></div>
                                                    </div>
                                                </div>
                                            </span>
                                        </button>
                                    )}
                                    <div
                                        className="wallet-details alert-details-popup"
                                        key={alert.alertId}
                                        id={`alert-${index}-details`}
                                        style={{ display: "none", padding: "0rem 1rem 1rem 3rem" }}
                                        aria-hidden="true"
                                    >
                                        <div className="data-grid row-height-xs" id={"alert-" + index + "-title"}>
                                            {keys.map((key: any) => {
                                                return (
                                                    <div key={`${key}-${index}`} className="data-row condensed row">
                                                        {key !== "Address" && key !== "Full Name" && (
                                                            <>
                                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                                    <div className="data-label" id={`alert-${index}-${key.split(" ").join("")}`}>
                                                                        {alert.alertDetails.alertItemDetails[key] !== "" && key}
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                                    <div className="data-value">
                                                                        {getFormattedDate(i18nService.get("Country"), alert.alertDetails.alertItemDetails[key])}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {alert &&
                            alert.historicalScan.length > 0 &&
                            alert.historicalScan.map((alert: any, index: number) => {
                                let addressData = alert["address"] + " " + alert["address2"];
                                return (
                                    <>
                                        {keys.length !== 0 && (
                                            <div role="listitem" className="data-row" key={alert.alertId}>
                                                <div className="link-item">
                                                    {values.length > 2 ? (
                                                        <button
                                                            type="button"
                                                            aria-expanded="false"
                                                            className="link-button alert-popup-focus"
                                                            id={`alert1-${index}`}
                                                            onClick={() => toggle(`alert1-${index}-details`, `alert1-${index}`)}
                                                        >
                                                            <span className="row link-item">
                                                                <div role="row" className="data-row condensed row">
                                                                    <span className="link-title">
                                                                        <span
                                                                            className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status"
                                                                            style={{ display: "none" }}
                                                                        >
                                                                            Show
                                                                        </span>{" "}
                                                                    </span>
                                                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                                        <div className="data-label" id={`alert1-${index}-Full-Name`}>Full Name</div>
                                                                    </div>
                                                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                        <div className="data-value" aria-labelledby={`alert1-${index}-Full-Name`}>
                                                                            {alert["first"]} {alert["last"]}
                                                                        </div>
                                                                    </div>
                                                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                                        <div className="data-label" id={`alert1-${index}-Address`}>Address</div>
                                                                    </div>
                                                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                        <div
                                                                            className="data-value"
                                                                            aria-labelledby={`alert1-${index}-Address`}
                                                                            dangerouslySetInnerHTML={{ __html: addressData }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </button>
                                                    ) : (
                                                        <button type="button" className="link-button link-item-value0" id={`alert-${index}`}>
                                                            <span className="row link-item">
                                                                <div role="row" className="data-row condensed row">
                                                                    <span className="link-title">
                                                                        <span
                                                                            className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status"
                                                                            style={{ display: "none" }}
                                                                        >
                                                                            Show
                                                                        </span>{" "}
                                                                    </span>
                                                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                                            <div className="data-label" id={`alert1${index}-Full-Name`}>Full Name</div>
                                                                    </div>
                                                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                        <div className="data-value" aria-labelledby={`alert1${index}-Full-Name`}>
                                                                            {alert["first"]} {alert["last"]}
                                                                        </div>
                                                                    </div>
                                                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                                            <div className="data-label" id={`alert-${index}-Address`}>Address</div>
                                                                    </div>
                                                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                        <div
                                                                            className="data-value"
                                                                            aria-labelledby={`alert-${index}-Address`}
                                                                            dangerouslySetInnerHTML={{ __html: addressData }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </button>
                                                    )}
                                                    <div
                                                        className="wallet-details alert-details-popup"
                                                        key={alert.alertId}
                                                        id={`alert-${index}-details`}
                                                        style={{ display: "none", padding: "0rem 1rem 1rem 3rem" }}
                                                        aria-hidden="true"
                                                    >
                                                        <div role="grid" className="data-grid row-height-xs" id={"alert-" + index + "-title"}>
                                                            {keys.map((key: any) => {
                                                                return (
                                                                    <div role="row" key={`${key}-${index}`} className="data-row condensed row">
                                                                        {key !== "Address" && key !== "Full Name" && (
                                                                            <>
                                                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                                                    <div className="data-label" id={`alert-${index}-${key.split(" ").join("")}`}>
                                                                                        {alert[key] !== "" && key}
                                                                                    </div>
                                                                                </div>
                                                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                                    <div className="data-value" aria-labelledby={`alert-${index}-${key.split(" ").join("")}`}>
                                                                                        {getFormattedDate(i18nService.get("Country"), alert[key])}
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                    </>
                );
            })}
        </>
    );
};

export default SexOffender;
